import { h, render, Component } from 'preact';

export default class MediaQuery extends Component {
	constructor(props) {
		super(props);
		this.state = {
			screenWidth: 0,
			deviceWidth: 0,
			mounted: false
		};
	}

	componentDidMount() {
		if (window.innerWidth) {
			this.setState({
				screenWidth: window.innerWidth,
				deviceWidth: window.innerWidth * window.devicePixelRatio,
				mounted: true
			});
		}
	}


	shouldRender = () => {
		let render = false;
		const { mounted } = this.state;
		const { minWidth, maxWidth } = this.props;
		let { screenWidth } = this.state;
		if (!mounted) {
			screenWidth = this.context.screenWidth;

		}

		if (minWidth && maxWidth) {
			render = screenWidth >= minWidth && this.screenWidth < maxWidth;
		} else if (minWidth) {
			render = screenWidth >= minWidth;
		} else {
			render = screenWidth < maxWidth;
		}
		return render;
	}

	render() {
		const { mounted, screenWidth } = this.state;
		const { minWidth, maxWidth } = this.props;
		const { className } = this.props;
		const render = this.shouldRender();

		return render ? <div className={className}>{this.props.children}</div> : null;
	}

}


// WEBPACK FOOTER //
// ../q-components/hoc/mediaQuery/index.js